<template>
    <div class="col-12 row form-group">
        <div class="col-6">
        <label class="my-0 mt-2" for="input-live">Application</label>
            <v-select id="application" label="name" :multiple="true" v-model="application" :options="applicationList"></v-select>
        </div>
        <div class="col-6">
            <label class="my-0 mt-2" for="input-live">Company</label>
            <v-select id="company" label="name" :multiple="true" v-model="company" :options="companyList"></v-select>
        </div>
        <div class="col-6">
        <label class="my-0 mt-2" for="input-live">Category</label>
            <v-select id="category" label="name" :multiple="true" v-model="category" :options="categoryList"></v-select>
        </div>
    </div>
</template>

<script>
    import { requestService } from './../../../_services';
    export default {
        components: {},
        props: {
        filterTab: Number,
        module:String
        },
        data() {
        return {
            application:[],
            applicationList:[],
            company:[],
            companyList:[],
            category:[],
            categoryList:[],
        };
        },

        watch: {
        // whenever question changes, this function will run
        filterTab(newValue, oldValue) {
            // let myFilter = JSON.parse(localStorage.getItem('filter-report-case'));
            // if (newValue == 1) {
            // this.dateStart = myFilter.dateStart;
            // this.dateEnd = myFilter.dateEnd;
            
            // } else {
            // this.dateStart = '';
            // this.dateEnd = '';
            // }
        },
        },
        mounted() {
            setTimeout(() => this.getCompany(), 1500);
            setTimeout(() => this.getApplication(), 2000);
            setTimeout(() => this.getCategory(), 2500);
        },
        methods: {
        async getCategory() {
            let url = `/api/category/all`;
            const resData = await requestService.GetFetch(this.module,url);
            const data = await resData.json();
            this.categoryList = data.data;
        },
        async getApplication() {
            let url = `/api/application/all`;
            const resData = await requestService.GetFetch(this.module,url);
            const data = await resData.json();
            this.applicationList = data.data;
        },
        async getCompany() {
            let url = `/api/company/all`;
            const resData = await requestService.GetFetch(this.module,url);
            const data = await resData.json();
            this.companyList = data.data;
        },
        getFilter() {
            var companyArr=[]
            this.company.forEach(element => {
                companyArr.push(element._id)
            });
            var applicationArr=[]
            this.application.forEach(element => {
                applicationArr.push(element._id)
            });
            var categoryArr=[]
            this.category.forEach(element => {
                categoryArr.push(element._id)
            });
            //text = fruits.join(" and ");
            let object = {
                company_id:companyArr.join(","),
                application_id:applicationArr.join(","),
                category_id:categoryArr.join(",")
            };
            return object;
        },
        inputHandler(eventData) {
            console.log(eventData);
        },
        },
    };
</script>

<style></style>
